import { Box } from "@mui/material";

import AvailabilityCalendarNavigationPanel from "./AvailabilityCalendarNavigationPanel";
import AvailabilityActionsPanel from "./AvailabilityActionsPanel";
import CalendarHeaderLayout from "../common/CalendarHeaderLayout";
import { MONTH_YEAR_FORMAT, WEEK_VIEW_DATE_FORMAT } from '../../config/DateTimeConstants';
import moment from 'moment-timezone';
import { Views } from "react-big-calendar";

const headerBoxStyles = {
    zIndex: 100,
    marginBottom: "0.5rem",
    marginTop: "0.05rem"
};

export default function MyAvailabilityViewHeader({ currentDate, currentView, onRefresh, onEnrollAll, onUnenrollAll, onNavigate, onView, isLoading }) {

    const ISO_WEEKDAY_MONDAY = 1;
    const ISO_WEEKDAY_SUNDAY = 7;

    const getHeaderTitle = (currentDate, currentView) => {

        const currentMoment = moment.isMoment(currentDate)
            ? currentDate.clone()
            : moment(currentDate);

        if (currentView === Views.WEEK) {
            const startOfWeek = currentMoment.clone().isoWeekday(ISO_WEEKDAY_MONDAY);
            const endOfWeek = currentMoment.clone().isoWeekday(ISO_WEEKDAY_SUNDAY);
            return `${startOfWeek.format(WEEK_VIEW_DATE_FORMAT)} - ${endOfWeek.format(WEEK_VIEW_DATE_FORMAT)}`;
        }

        return currentMoment.format(MONTH_YEAR_FORMAT);
    };

    return (
        <Box sx={headerBoxStyles}>
            <CalendarHeaderLayout
                actionPanelContainer={<AvailabilityCalendarNavigationPanel onNavigate={onNavigate} onView={onView} currentView={currentView} />}
                titleContainer={getHeaderTitle(currentDate, currentView)}
                contextOptionContainer={<AvailabilityActionsPanel onRefresh={onRefresh} isLoading={isLoading} onEnrollAll={onEnrollAll} onUnenrollAll={onUnenrollAll} currentView={currentView} />}
            />
        </Box>
    );
}
